'use client';

import { useTranslations } from 'next-intl';

import { UiProductInfoCharacteristics } from '@/fo/ui/product/info/characteristics';
import { MappedProduct } from '@/fo/util/map-product-data';

import { styles } from './UiProductInfoPanel.styles';

export interface UiProductInfoPanelProps {
  product: MappedProduct;
  activeIndex?: number;
  onTabChange?: (index: number) => void;
}

export function UiProductInfoPanel({ product }: UiProductInfoPanelProps) {
  const t = useTranslations();

  const slots = styles();

  return (
    <div className={slots.base()}>
      <h2 className={slots.title()}>{t('product.tabs.characteristics')}</h2>
      <UiProductInfoCharacteristics product={product} />
    </div>
  );
}
